import RoleCode from '@/constants/RoleCode'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: {
    icon: string
    roles?: string[]
    level?: number // Mức level tối thiểu cho OCT
    isSection?: boolean
    usernames?: string[] // Giới hạn theo username cụ thể (VD: chỉ super_admin)
  }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // ── Menu chính ──────────────────────────────────────────
    {
      name: 'section-main',
      displayName: 'menu.section-main',
      meta: { icon: '', isSection: true },
    },
    {
      name: 'vehicle-trackings',
      displayName: 'menu.vehicle-trackings',
      meta: { icon: 'electric_rickshaw', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },
    {
      name: 'customs-declarations',
      displayName: 'menu.customs-declarations',
      meta: { icon: 'receipt_long', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },
    {
      name: 'additional-cost-requests',
      displayName: 'menu.additional-cost-requests',
      meta: { icon: 'request_quote', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },

    // ── Bảng giá Chi phí ─────────────────────────────────────
    {
      name: 'section-price',
      displayName: 'menu.section-price',
      meta: { icon: '', isSection: true },
    },
    {
      name: 'af-input-fees',
      displayName: 'menu.af-input-fees',
      meta: { icon: 'credit_card' },
      children: [
        // OCT level 1 chỉ được xem 3 loại: Cước vận chuyển, Phí lưu xe, Trả điểm
        {
          name: 'input-transportation-fee',
          displayName: 'menu.transportation-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'input-transportation-fee-history',
          displayName: 'menu.transportation-fee-history',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'input-drop-point-fee',
          displayName: 'menu.drop-point-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'input-detention-fee',
          displayName: 'menu.detention-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        // KTĐV/KTĐR xem được TẤT CẢ phí đầu vào (OCT level 1 chỉ xem 4 loại trên)
        {
          name: 'input-border-procedure-fee',
          displayName: 'menu.border-procedure-fee',
          meta: { icon: '', roles: [RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'input-icd-fee',
          displayName: 'menu.icd-fee',
          meta: { icon: '', roles: [RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
      ],
    },
    {
      name: 'af-output-fees',
      displayName: 'menu.af-output-fees',
      meta: { icon: 'credit_card' },
      children: [
        // KTĐR xem được menu Phí đầu ra ở cả 2 level (level 1 chỉ view, level 2 mới có hành động —
        // xem GROUP_FULL_ACCESS['af-output-fees']). OCT level 1 chỉ xem 4 loại đầu.
        {
          name: 'output-transportation-fee',
          displayName: 'menu.transportation-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'output-transportation-fee-history',
          displayName: 'menu.output-transportation-fee-history',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'output-drop-point-fee',
          displayName: 'menu.drop-point-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        {
          name: 'output-detention-fee',
          displayName: 'menu.detention-fee',
          meta: { icon: '', roles: [RoleCode.OCT, RoleCode.KTDR, RoleCode.BOD], level: 1 },
        },
        // KTĐR xem được TẤT CẢ phí đầu ra (OCT level 1 chỉ xem 4 loại trên)
        {
          name: 'output-border-procedure-fee',
          displayName: 'menu.border-procedure-fee',
          meta: { icon: '', roles: [RoleCode.KTDR, RoleCode.BOD] },
        },
        {
          name: 'output-transloading-fee',
          displayName: 'menu.transloading-fee',
          meta: { icon: '', roles: [RoleCode.KTDR, RoleCode.BOD] },
        },
        {
          name: 'output-overnight-fee',
          displayName: 'menu.overnight-fee',
          meta: { icon: '', roles: [RoleCode.KTDR, RoleCode.BOD] },
        },
        {
          name: 'output-disbursement-fee',
          displayName: 'menu.disbursement-fee',
          meta: { icon: '', roles: [RoleCode.KTDR, RoleCode.BOD] },
        },
        {
          name: 'output-icd-fee',
          displayName: 'menu.icd-fee',
          meta: { icon: '', roles: [RoleCode.KTDR, RoleCode.BOD] },
        },
      ],
    },

    // ── Công nợ ──────────────────── (BOD xem hết; KTDV chỉ thấy Công nợ NCC; KTDR chỉ thấy Công nợ KH)
    {
      name: 'section-debt',
      displayName: 'menu.section-debt',
      meta: { icon: '', isSection: true, roles: [RoleCode.BOD, RoleCode.KTDV, RoleCode.KTDR] },
    },
    {
      name: 'completed-vehicle-trackings',
      displayName: 'menu.vehicle-tracking-export-full',
      meta: { icon: 'download', roles: [RoleCode.BOD] },
    },
    {
      name: 'debts',
      displayName: 'menu.debts',
      meta: { icon: 'local_shipping', roles: [RoleCode.BOD, RoleCode.KTDR] },
    },
    {
      name: 'supplier-payables',
      displayName: 'menu.supplier-payables',
      meta: { icon: 'assignment_ind', roles: [RoleCode.BOD, RoleCode.KTDV] },
    },

    // ── Danh mục ─────────────────────────────────────────────
    {
      name: 'section-category',
      displayName: 'menu.section-category',
      meta: { icon: '', isSection: true, roles: [RoleCode.BOD, RoleCode.OCT], level: 2 },
    },
    {
      name: 'cat-fee-group',
      displayName: 'menu.cat-fee-group',
      meta: { icon: 'payments', roles: [RoleCode.BOD, RoleCode.OCT], level: 2 },
      children: [
        { name: 'fee-groups', displayName: 'menu.fee-groups', meta: { icon: '' } },
        { name: 'fees', displayName: 'menu.fees', meta: { icon: '' } },
      ],
    },
    {
      name: 'cat-status-group',
      displayName: 'menu.cat-status-group',
      meta: { icon: 'toggle_on', roles: [RoleCode.BOD, RoleCode.OCT], level: 2 },
      children: [
        { name: 'declaration-statuses', displayName: 'menu.declaration-statuses', meta: { icon: '' } },
        { name: 'vehicle-statuses', displayName: 'menu.vehicle-statuses', meta: { icon: '' } },
        { name: 'tq-vehicle-statuses', displayName: 'menu.tq-vehicle-statuses', meta: { icon: '' } },
        { name: 'vn-vehicle-statuses', displayName: 'menu.vn-vehicle-statuses', meta: { icon: '' } },
      ],
    },
    {
      name: 'cat-mtk-group',
      displayName: 'menu.cat-mtk-group',
      meta: { icon: 'gavel', roles: [RoleCode.BOD, RoleCode.OCT], level: 2 },
      children: [
        { name: 'declaration-agencies', displayName: 'menu.declaration-agencies', meta: { icon: '' } },
        { name: 'customs-declaration-services', displayName: 'menu.customs-declaration-services', meta: { icon: '' } },
      ],
    },
    {
      name: 'cat-other-group',
      displayName: 'menu.cat-other-group',
      meta: { icon: 'more_horiz', roles: [RoleCode.BOD, RoleCode.OCT], level: 2 },
      children: [
        { name: 'debits', displayName: 'menu.debits', meta: { icon: '' } },
        { name: 'bookers', displayName: 'menu.bookers', meta: { icon: '' } },
        { name: 'vehicle-types', displayName: 'menu.vehicle-types', meta: { icon: '' } },
        { name: 'declaration-customers', displayName: 'menu.declaration-customers', meta: { icon: '' } },
        { name: 'logistics-services', displayName: 'menu.logistics-services', meta: { icon: '' } },
        { name: 'suppliers', displayName: 'menu.suppliers', meta: { icon: '' } },
        { name: 'border-gates', displayName: 'menu.border-gates', meta: { icon: '' } },
        { name: 'actual-locations', displayName: 'menu.actual-locations', meta: { icon: '' } },
        { name: 'billing-locations', displayName: 'menu.billing-locations', meta: { icon: '' } },
      ],
    },
    {
      name: 'cat-management-group',
      displayName: 'menu.cat-management-group',
      meta: { icon: 'manage_accounts' },
      children: [
        { name: 'users', displayName: 'menu.users', meta: { icon: '', roles: [RoleCode.BOD] } },
        { name: 'departments', displayName: 'menu.departments', meta: { icon: '', roles: [RoleCode.BOD] } },
      ],
    },
    {
      name: 'cat-permission-group',
      displayName: 'menu.permission-group',
      meta: { icon: 'admin_panel_settings', roles: [RoleCode.BOD] },
      children: [
        {
          name: 'permission-matrix',
          displayName: 'menu.permission-function',
          meta: { icon: '', roles: [RoleCode.BOD] },
        },
        {
          // Không phải route thật (chỉ là nhãn/accordion lồng cấp 2) — 2 trang thật nằm ở children.
          // Dùng đúng tên 'permission-data' để giữ nguyên quyền can_read sẵn có trong role_permission.
          name: 'permission-data',
          displayName: 'menu.permission-data',
          meta: { icon: '', roles: [RoleCode.BOD] },
          children: [
            {
              name: 'permission-data-vehicle-tracking',
              displayName: 'menu.permission-data-vehicle-tracking',
              meta: { icon: '', roles: [RoleCode.BOD] },
            },
            {
              name: 'permission-data-debt',
              displayName: 'menu.permission-data-debt',
              meta: { icon: '', roles: [RoleCode.BOD] },
            },
          ],
        },
      ],
    },

    // ── Hướng dẫn ────────────────────────────────────────────
    {
      name: 'section-guide',
      displayName: 'menu.section-guide',
      meta: { icon: '', isSection: true },
    },
    {
      name: 'user-guide',
      displayName: 'menu.user-guide',
      meta: { icon: 'menu_book', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },
    {
      name: 'work-guides',
      displayName: 'menu.work-guides',
      meta: { icon: 'menu_book', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },
    {
      name: 'template-files',
      displayName: 'menu.template-files',
      meta: { icon: 'description', roles: [RoleCode.OCT, RoleCode.KTDV, RoleCode.KTDR, RoleCode.BOD], level: 1 },
    },

    // ── Hệ thống ─────────────────────────────────────────────
    {
      name: 'section-system',
      displayName: 'menu.section-system',
      meta: { icon: '', isSection: true, usernames: ['super_admin'] },
    },
    {
      name: 'system-configs',
      displayName: 'menu.system-configs',
      meta: { icon: 'settings', usernames: ['super_admin'] },
    },
    {
      name: 'import-export-logs',
      displayName: 'menu.import-export-logs',
      meta: { icon: 'swap_vert', usernames: ['super_admin'] },
    },
    {
      name: 'error-logs',
      displayName: 'menu.error-logs',
      meta: { icon: 'bug_report', usernames: ['super_admin'] },
    },
    {
      name: 'job-execution-logs',
      displayName: 'menu.job-execution-logs',
      meta: { icon: 'history', usernames: ['super_admin'] },
    },
    {
      name: 'vehicle-tracking-column-configs',
      displayName: 'menu.vehicle-tracking-column-configs',
      meta: { icon: 'view_column', usernames: ['super_admin'] },
    },
    {
      name: 'debt-column-configs',
      displayName: 'menu.debt-column-configs',
      meta: { icon: 'view_column', usernames: ['super_admin'] },
    },
    {
      name: 'supplier-payable-column-configs',
      displayName: 'menu.supplier-payable-column-configs',
      meta: { icon: 'view_column', usernames: ['super_admin'] },
    },
  ] as INavigationRoute[],
}
